import React, {useState, useRef} from "react";
import {useSelector} from "react-redux";
import {injectIntl} from "react-intl";
import classNames from "classnames";
import {useClickOutside} from "hooks";
import {CHAT_TYPE, WORLD_CHAT_COLOR} from "utils/constants";
import {TwoBtnPopUp, showPopUp} from "components/PopUp";
import {notify} from "components/VoiceChat/Components/Notify";
// import MyInfo from "components/PopUp/MyInfo";
import worldIcon from "images/chat/ic_world_chat.svg";
import worldIcon_black from "images/chat/ic_world_chat_black.svg";
import styles from "./index.module.scss";

function Message({intl, data}) {
  const messageRef = useRef(null);
  useClickOutside(messageRef, () => setIsClick(false));
  const {userCi, type, message, color} = data;
  const [isClick, setIsClick] = useState(false);
  const [menuBoxXPos, setMenuBoxXPos] = useState(0);
  const [menuBoxYPos, setMenuBoxYPos] = useState(0);
  const userInfo = useSelector(state => state.userinfo);
  let content = "";

  const onClickRight = e => {
    e.preventDefault();
    const _userCi = userCi ? userCi : data.from.userCi;
    if (userInfo.id === _userCi) return;

    if (e.type === "contextmenu" || e.type === "touchend") {
      setIsClick(true);
      const {top, left} = messageRef.current.getBoundingClientRect();
      setMenuBoxXPos((e.pageX ? e.pageX : e.changedTouches[0].clientX) - left + 80);
      setMenuBoxYPos(top);
    }
  };

  const onClickProfile = () => {
    // setIsClick(false);
    // const _userCi = userCi ? userCi : data.from.userCi;
    // showPopUp(<MyInfo otherId={_userCi} isMyInfo={false} />, {
    //   isOverlapPopup: true,
    //   defaultPadding: false,
    //   dismissButton: true,
    //   closeEscButton: true,
    // });
  };

  // NOTE : not working anymore
  const onClickBlock = () => {};

  switch (type) {
    case CHAT_TYPE.MESSAGE:
    case CHAT_TYPE.WORLD_MESSAGE:
      const {name} = data;
      content = `${name} : ${message}`;
      break;
    case CHAT_TYPE.PRIVATE_MESSAGE:
      const {to, from} = data;
      if (userInfo.id === from.userCi) {
        content = `[${to.name}]에게 : ${message}`;
      } else {
        content = `[${from.name}] : ${message}`;
      }
      break;
    case CHAT_TYPE.INVALIDATE:
      const {ttl} = data;
      if (message === "badword-1st-warning") {
        content = intl.formatMessage({id: "ID_INVALIDATION_BAD_WORD_1ST"}, {ttl});
      }
      if (message === "badword-2st-warning") {
        content = intl.formatMessage({id: "ID_INVALIDATION_BAD_WORD_2ST"}, {ttl});
      }
      if (message === "world-chatting-cool-time") {
        content = intl.formatMessage({id: "ID_INVALIDATION_WORLD_CHAT_COOL_TIME"}, {ttl});
      }
      if (message === "connection-error") {
        content = intl.formatMessage({
          id: "ID_INVALIDATION_CONNECTION_ERROR",
        });
      }
      if (message === "user-does-not-exist-in-the-world") {
        content = intl.formatMessage({id: "ID_INVALIDATION_NOT_USER_EXIST"});
      }
      break;
    default:
      break;
  }

  const isWorldMessage = type === CHAT_TYPE.WORLD_MESSAGE;
  const isPrivateMessage = type === CHAT_TYPE.PRIVATE_MESSAGE;
  const isInvalidateMessage = type === CHAT_TYPE.INVALIDATE;

  const isBlackPalette = [WORLD_CHAT_COLOR[4], WORLD_CHAT_COLOR[6], WORLD_CHAT_COLOR[9]].includes(color);

  const getColor = () => {
    let color = "#fff";
    if (isBlackPalette) {
      color = "#000";
    }
    if (isPrivateMessage) {
      color = "#14F1FF";
    }
    if (isInvalidateMessage) {
      color = "#FFD130";
    }
    return color;
  };

  return (
    <div
      className={classNames(styles.chat_message, isWorldMessage && styles.world_message, isPrivateMessage && styles.private_message)}
      onContextMenu={onClickRight}
      onTouchEnd={onClickRight}
      ref={messageRef}
      style={{backgroundColor: color ? color : "transparent"}}
    >
      {isWorldMessage && <img src={isBlackPalette ? worldIcon_black : worldIcon} alt="" />}
      <p style={{color: getColor()}}>{content}</p>
      {isClick && (
        <ul className={styles.chat_message_menu} style={{top: menuBoxYPos, left: menuBoxXPos}}>
          <li>{data.name ? data.name : data.from.name}</li>
          <li onClick={onClickProfile} onTouchEnd={onClickProfile}>
            {intl.formatMessage({id: "ID_CHAT_MENU_PROFILE"})}
          </li>
          <li onClick={onClickBlock} onTouchEnd={onClickBlock}>
            {intl.formatMessage({id: "ID_CHAT_MENU_BLOCK"})}
          </li>
        </ul>
      )}
    </div>
  );
}

export default injectIntl(Message);
